<div class="mat-margin-top mat-justify-content-center mat-align-items-center">
	<mat-form-field appearance="fill">
		<mat-label>Choose a date</mat-label>
		<input matInput [matDatepicker]="monthPicker" [max]="maxMonth" [formControl]="monthSelector" />
		<mat-datepicker-toggle matSuffix [for]="monthPicker"></mat-datepicker-toggle>
		<mat-datepicker #monthPicker startView="year" [startAt]="startDate"
			(monthSelected)="chosenMonthHandler($event, monthPicker)"></mat-datepicker>
	</mat-form-field>
</div>
<div class="mat-margin-top mat-justify-content-center mat-align-items-center">
	<button mat-raised-button class="generateButton cancelBtn" expand="block" (click)="cancel()">Cancel</button>
	@if (!downloading) {
	<button mat-raised-button class="primary-btn generateButton" expand="block" (click)="exportReport()">
		Generate
	</button>
	}
	@if (downloading) {
	<mat-spinner class="downloadSpinner"></mat-spinner>
	}
</div>